<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <!-- <el-form-item>
          <el-input v-model="filters.name" placeholder="用户名"></el-input>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" v-on:click="getOrders">查询</el-button>
          <el-button type="primary" v-on:click="createOrders"
            >新增订单</el-button
          >
        </el-form-item>
        <!-- <el-form-item v-if="isSuperAdmin">
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>-->
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="orders"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
      fixed
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column type="index" width="70"></el-table-column>
      <el-table-column
        prop="from"
        width="70"
        label="渠道"
        :formatter="
          (row) => (fromMap[row.from])
        "
      ></el-table-column>
      <el-table-column prop="orderId" label="订单ID"></el-table-column>
      <el-table-column
        prop="handleStatus"
        label="处理状态"
        :formatter="(row) => getHandleStatus(row)"
      ></el-table-column>
      <el-table-column
        width="150"
        prop="hotel_id"
        label="酒店名"
        :formatter="
          (row) =>
            row.hotel_id
              ? hotelMap[row.hotel_id][fromNameMap[row.from]] || hotelMap[row.hotel_id].tzName
              : '-'
        "
      ></el-table-column>
     
      <el-table-column label="日期" width="220">
        <template scope="s">
          <p>
            入住日期
            {{ fecha.format(new Date(s.row.checkInDate), "YYYY-MM-DD") }}
          </p>
          <p>
            离店日期
            {{ fecha.format(new Date(s.row.checkOutDate), "YYYY-MM-DD") }}
          </p>
          <p>{{ s.row.stay }}晚</p>
          <p>{{ s.row.roomCount }}间</p>
          <p>早餐 {{ s.row.breakfirst || 0 }} 份</p>
        </template>
      </el-table-column>
      <el-table-column label="价格">
        <template scope="s">
          <p>价格 {{ s.row.price }}</p>
          <p>原价 {{ s.row.floorPrice }}</p>
          <p>立减 {{ s.row.discount }}</p>
          <p>利润 {{ s.row.commission }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="guestName" label="客户名"></el-table-column>
      <el-table-column prop="goodsName" label="房型"></el-table-column>
      <el-table-column label="结算方式" width="200">
        <template slot-scope="s">
          <p>{{ getPay(s.row) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="note" label="备注"></el-table-column>

      <el-table-column label="操作" width="150">
        <template scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >发送</el-button
          >
          <!-- <el-button
            v-if="!scope.row.handleStatus"
            type="danger"
            size="small"
            @click="handleSend(scope.$index, scope.row)"
          >发送{{scope.row.handleStatus}}</el-button>
          <el-button type="text" v-else disabled>{{getHandleStatus(scope.row)}}</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >-->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="价格" prop="price">
          <el-input
            v-model="editForm.price"
            type="number"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="原价" prop="floorPrice">
          <el-input
            v-model="editForm.floorPrice"
            type="number"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="立减" prop="discount">
          <el-input
            v-model="editForm.discount"
            type="number"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="酒店" prop="hotel_id">
          <el-select
            filterable
            v-model="editForm.hotel_id"
            class="long-select"
            @change="(hId) => getPayByHotel(hId, 'editForm')"
          >
            <el-option
              v-for="(hotel, index) in hotels"
              :key="index"
              :value="+hotel[0]"
              :label="
                hotel[1][fromNameMap[editForm.from]] || hotel[1].tzName
              "
            />
          </el-select>
        </el-form-item>
        <el-form-item label="早餐" prop="breakfirst" required>
          <el-input
            type="number"
            v-model="editForm.breakfirst"
            placeholder="早餐"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="editForm.note" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="取消订单" prop="cancel">
          <el-select v-model="editForm.cancel">
            <el-option :value="0" label="否"></el-option>
            <el-option :value="1" label="取消"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式" prop="pay">
          <el-select v-model="editForm.pay">
            <el-option :value="1" label="日结"></el-option>
            <el-option :value="2" label="周结"></el-option>
            <el-option :value="3" label="月结"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="渠道" prop="from">
          <el-select v-model="addForm.from">
            <el-option label="同舟" :value="1" />
            <el-option label="代理通" :value="2" />
            <el-option label="同程" :value="3" />
            <el-option label="飞猪" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="酒店" prop="hotel_id" required>
          <el-select
            filterable
            v-model="addForm.hotel_id"
            class="long-select"
            @change="(hId) => getPayByHotel(hId, 'addForm')"
          >
            <el-option
              v-for="(hotel, index) in hotels"
              :key="index"
              :value="+hotel[0]"
              :label="hotel[1][fromNameMap[addForm.from]] || hotel[1].tzName"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="原价" prop="floorPrice" required>
          <el-input
            type="number"
            v-model="addForm.floorPrice"
            placeholder="酒店原价"
          ></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="price" required>
          <el-input
            type="number"
            v-model="addForm.price"
            placeholder="价格"
          ></el-input>
        </el-form-item>
        <el-form-item label="立减" prop="discount" required>
          <el-input
            type="number"
            v-model="addForm.discount"
            placeholder="立减"
          ></el-input>
        </el-form-item>
        <el-form-item label="房型" prop="goodsName" required>
          <el-input
            type="text"
            v-model="addForm.goodsName"
            placeholder="房型"
          ></el-input>
        </el-form-item>
        <el-form-item label="客人姓名" prop="guestName" required>
          <el-input
            type="text"
            v-model="addForm.guestName"
            placeholder="客人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="入住离开日期" required>
          <el-date-picker
            v-model="addForm.dates"
            type="daterange"
            range-separator="至"
            start-placeholder="入住日期"
            end-placeholder="离店日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="房间数" prop="roomCount" required>
          <el-input
            type="number"
            v-model="addForm.roomCount"
            placeholder="房间数"
          ></el-input>
        </el-form-item>
        <el-form-item label="早餐" prop="breakfirst" required>
          <el-input
            type="number"
            v-model="addForm.breakfirst"
            placeholder="早餐"
          ></el-input>
        </el-form-item>
        <el-form-item label="结算方式" prop="pay">
          <el-select v-model="addForm.pay">
            <el-option :value="1" label="日结"></el-option>
            <el-option :value="2" label="周结"></el-option>
            <el-option :value="3" label="月结"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../common/js/util";
import NProgress from "nprogress";
import { adminApi, hotelApi, orderApi } from "../../api/api";
import { mapGetters } from "vuex";
import fecha from "fecha";
import { tzOrderStatusMap, handleStatusMap, fromMap, fromNameMap } from "../../constant";
const defaultAddform = {
  from: 1,
  hotel_id: null,
  floorPrice: 0,
  price: 0,
  discount: 0,
  checkInDate: "",
  checkOutDate: "",
  guestName: "",
  goodsName: "",
  stay: 1,
  roomCount: 1,
  breakfirst: 0,
  dates: [],
};
export default {
  data() {
    return {
      fromNameMap,
      fromMap,
      stausMap: {},
      hotelMap: {},
      hotels: [],
      filters: {
        name: "",
      },
      orders: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        //   role: [{ required: true, message: '请输入角色', trigger: 'blur' }],
      },
      //编辑界面数据
      editForm: {
        note: "",
        discount: 0,
        floorPrice: 0,
        price: 0,
        id: "",
        hotel_id: "",
        cancel: 0,
        breakfirst: 0,
        pay: "",
        from: 1,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        from: 1,
        hotel_id: null,
        floorPrice: 0,
        price: 0,
        discount: 0,
        checkInDate: "",
        checkOutDate: "",
        guestName: "",
        goodsName: "",
        stay: 1,
        roomCount: 1,
        breakfirst: 0,
        dates: [],
        pay: "",
      },
    };
  },
  methods: {
    getPayByHotel(hotelId, form) {
      this[form].pay = this.hotelMap[hotelId] ? this.hotelMap[hotelId].pay : "";
    },
    //性别显示转换
    formatRole: function (row, column) {
      return row.role == 0 ? "超级管理员" : "普通管理员";
    },
    getPay(row) {
      const e = {
        1: "日结",
        2: "周结",
        3: "月结",
      };
      return e[row.pay] || "-";
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getOrders();
    },
    //获取用户列表
    getOrders() {
      let para = {
        page: this.page,
        book: 1,
      };
      this.listLoading = true;
      NProgress.start();
      orderApi.list(para).then((res) => {
        this.total = res.data.count;
        res.data.rows.forEach((row) => {
          row.price = row.price / 100;
          row.floorPrice = row.floorPrice / 100;
          row.discount = row.discount / 100;
          row.commission = row.commission / 100;
        });
        this.orders = res.data.rows;
        this.listLoading = false;
        NProgress.done();
      });
    },
    createOrders() {
      this.addFormVisible = true;
    },
    getOrderStatus(row) {
      const map = row.from == 1 ? tzOrderStatusMap : {};
      return map[row.orderStatus] || row.orderStatus;
    },
    getHandleStatus(row) {
      return !!row.handleStatus
        ? handleStatusMap[row.handleStatus] || "未处理"
        : "未处理";
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign(this.editForm, row);
      if(!this.editForm.pay && this.hotelMap[row.hotel_id] && this.hotelMap[row.hotel_id].pay){
        this.editForm.pay =  this.hotelMap[row.hotel_id].pay
      }
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (!this.editForm.cancel) {
            if (!this.editForm.hotel_id) {
              return this.$message.error("请先选择酒店");
            }
            if (!this.editForm.price) {
              return this.$message.error("请设置订单价格");
            }
          }
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign(
                { judgeHandleStatus: 1 },
                this.editForm,
                {
                  handleStatus: "0", // 设置为管理员更新，但操作员没有更新的状态
                }
              );
              orderApi.update(para).then((res) => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                //this.handleSend(0, para);
                this.getOrders();
              });
            })
            .finally((_) => {
              this.editLoading = false;
            });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            this.addForm.checkInDate = this.addForm.dates[0];
            this.addForm.checkOutDate = this.addForm.dates[1];
            let para = Object.assign({}, this.addForm);
            orderApi.createOrder(para).then((res) => {
              this.addLoading = false;
              //NProgress.done();
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.addForm = Object.assign({}, defaultAddform);
              this.getOrders();
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      var ids = this.sels.map((item) => item.id).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: ids };
          batchRemoveUser(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getOrders();
          });
        })
        .catch(() => {});
    },
    getHotelMap() {
      hotelApi.listMap().then(({ data }) => {
        this.hotelMap = data;
        this.hotels = Object.entries(data);
      });
    },
  },
  created() {
    this.fecha = fecha;
  },
  mounted() {
    this.getHotelMap();
    this.getOrders();
  },
  computed: {
    ...mapGetters(["getUserInfo", "isSuperAdmin"]),
  },
};
</script>

<style scoped>
.long-select {
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// book.vue?25757428